/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { keyCodes } from '@blend/shared-react';

import AutocompletePrediction from '../../../../types/autocompletePrediction';
import * as googlePlacesUtils from './utils/googlePlacesUtils';
import { includes } from '@utils/lodash';

// Clear for space, delete, backspace.
export const isClearCharacter = (keyCode: number) => {
  return includes([keyCodes.BACKSPACE, keyCodes.ESCAPE, keyCodes.DELETE, keyCodes.SPACE], keyCode);
};

export const getAutocompleteResults = async (
  searchText: string,
  autocompleteSessionToken?: google.maps.places.AutocompleteSessionToken,
  isCityOnlyInput?: boolean,
): Promise<AutocompletePrediction[]> => {
  const overrideParams = isCityOnlyInput ? { types: ['(cities)'] } : {};
  const googleResults = await googlePlacesUtils.getAutocompleteMatches(
    searchText,
    autocompleteSessionToken,
    overrideParams,
  );
  return googleResults.map(result => ({
    apiResult: result,
    description: result.description,
  }));
};
